import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

import Padres from './views/Padres.vue'
import PadresDescargas from './views/PadresDescargas.vue'

import Contacto from './views/Contacto.vue'


Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    
    
    {
      path: '/',
      name: 'Padres',
      component: Padres
    },
    {
      path: '/descargas',
      name: 'descargas',
      component: PadresDescargas
    },
    
    {
      path: 'https://lalabumapp.com/index.php/contacto/',
      name: 'contacto',
      component: Contacto
    }
  ]
})

router.beforeEach((to,from,next)=>{
  if (to.matched.some(record=>record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
          next()
          return
      }
      next('/Padres')
  }else{
      next()
  }
})

export default router